import { $logger } from '@/boot/logger'

/**
 * @description Check if the user can enter the test routes
 * @function checkEntrance
 */
async function checkEntrance() {
  const isDev = import.meta.env.MODE === 'development' || import.meta.env.DEV || process.env.NODE_ENV === 'development'
  // If not on env DEV, deny entry to test route
  if (!isDev) {
    $logger.debug('tests.routes => Access denied to test routes outside of DEV environment')
    return { name: 'ErrorPage' }
  }

  // Allow access in DEV environment
  $logger.debug('tests.routes => Access granted to test routes in DEV environment')
}

export default [
  {
    path: '/tests',
    component: () => import('src/layouts/shared/MinimalLayout.vue'),
    meta: {
      layout: {
        header: {
          showSlogan: true,
        },
      },
    },
    children: [
      {
        path: 'image-resize-test',
        name: 'ImageResizeTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/ImageResizeTest.vue'),
      },
      {
        path: 'pegged-loader-test',
        name: 'PeggedLoaderTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/PeggedLoaderTest.vue'),
      },
    ],
  },
  {
    path: '/tests',
    component: () => import('src/layouts/app/AppReturnLayout.vue'),
    children: [
      {
        path: 'app-return-confirmation',
        name: 'AppReturnConfirmationTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/AppReturnConfirmationTest.vue'),
        meta: {
          layout: {
            contentful: true,
            showBottomNav: false,
          },
        },
      },
      {
        path: 'app-return-summary',
        name: 'AppReturnSummaryTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/AppReturnSummaryTest.vue'),
        meta: {
          layout: {
            contentful: true,
            showBottomNav: false,
          },
        },
      },
      {
        path: 'app-return-wrong-item',
        name: 'AppReturnWrongItemTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/AppReturnWrongItemInterfaceTest.vue'),
        meta: {
          layout: {
            contentful: true,
            showBottomNav: false,
          },
        },
      },
      {
        path: 'app-return-packaging-assessment',
        name: 'AppReturnPackagingAssessmentTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/AppReturnPackagingAssessmentTest.vue'),
        meta: {
          layout: {
            contentful: true,
            showBottomNav: false,
          },
        },
      },
      {
        path: 'app-return-product-state-assessment',
        name: 'AppReturnProductStateAssessmentTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/AppReturnProductStateAssessmentTest.vue'),
        meta: {
          layout: {
            contentful: true,
            showBottomNav: false,
          },
        },
      },
      {
        path: 'app-return-resolution-choice',
        name: 'AppReturnResolutionChoiceTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/AppReturnResolutionChoiceTest.vue'),
        meta: {
          layout: {
            contentful: true,
            showBottomNav: false,
          },
        },
      },
    ],
  },
  {
    path: '/tests',
    component: () => import('src/layouts/shared/MinimalLayout.vue'),
    children: [
      {
        path: 'delivery-verification',
        name: 'DeliveryVerificationPageTest',
        beforeEnter: checkEntrance,
        component: () => import('src/pages/tests/DeliveryVerificationPageTest.vue'),
      },
    ],
  },
]
